import { neuron } from "./neuron";
import { NeuronClient } from "./NeuronClient";
import { PrivateNeuronClient } from "./PrivateNeuronClient";

export { neuron, NeuronClient, PrivateNeuronClient };
globalThis["ReactNeuron"] = {
  neuron,
  NeuronClient,
  PrivateNeuronClient,
};
